module.exports = __webpack_public_path__ + "img/embellishment-left.6ecf8a31.svg";